import type { DateString } from "@/types/common"
import type { PatientPeriod, PatientPeriodFlowIntensity } from "@/types/patient"
import { API_ROOT, HttpClient } from "@/api/httpClient"

export interface PeriodPayload {
	start_date: DateString
	flow_intensity: PatientPeriodFlowIntensity
	symptoms?: string | null
}

export default {
	list(patientId: number) {
		return HttpClient.get<PatientPeriod[]>(`${API_ROOT}/patients/${patientId}/periods`)
	},
	create(patientId: number, payload: PeriodPayload) {
		return HttpClient.post<PatientPeriod>(`${API_ROOT}/patients/${patientId}/periods`, payload)
	},
	update(patientId: number, periodId: number, payload: PeriodPayload) {
		return HttpClient.put<PatientPeriod>(`${API_ROOT}/patients/${patientId}/periods/${periodId}`, payload)
	},
	delete(patientId: number, periodId: number) {
		return HttpClient.delete(`${API_ROOT}/patients/${patientId}/periods/${periodId}`)
	}
}
